module.exports = __webpack_public_path__ + "img/ovc2.5fe7d864.png";